import React from "react";
import useLocales from "../../../hooks/useLocales";
import ExtraSmallFilledButtonComponent from "../../common/buttons/ExtraSmallFilledButtonComponent";

// Confirmation Modal Component
// Receive Modal Component props - isOpen it a boolean state(variable), onCancel a function that is called when the user clicks on cancel button, onConfirm a function that is called when the user clicks on confirm button.
//

const ConfirmModal = ({ isOpen, onCancel, onConfirm, selectedLang }) => {
  const { tComponent } = useLocales();
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 h-screen w-screen flex items-center justify-center z-50"
      style={{
        direction: selectedLang === "ar" ? "rtl" : "ltr",
      }}
    >
      <div className="absolute h-screen w-screen inset-0 bg-gray-800 opacity-50"></div>
      <div className="bg-white rounded-lg p-6 z-10 dark:bg-dark-secondary">
        <p className="text-body_copy1 mb-4 dark:text-color_v1_dark">{tComponent(`want_to_delete`)}</p>
        <div className="flex items-center justify-end">
          <button className="text-small2_b gray-700 dark:text-color_v1_dark" onClick={onCancel}>
            {tComponent(`cancel`)}
          </button>

          <ExtraSmallFilledButtonComponent
            name={`${tComponent("delete_cap")}`}
            buttonType={"button"}
            onClickHandler={onConfirm}
            classes={"ms-3"}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
